/**
 * Hide empty paragraphs that contain only <br> tags, &nbsp;, or whitespace, including nested structures
 * Handles cases like: 
 * - <p><br></p>
 * - <p><span><br></span></p>
 * - <p><span><font><br></font></span></p>
 * - <p>&nbsp;</p>
 * - <p style="color: rgb(53, 53, 53); font-family: Arial; font-size: 14pt;">&nbsp;</p>
 */
(function() {
  'use strict';

  function isParagraphEffectivelyEmpty(paragraph) {
    // Clone the paragraph to avoid modifying the original during testing
    const clone = paragraph.cloneNode(true);
    
    // Remove all <br> tags
    const brs = clone.querySelectorAll('br');
    brs.forEach(br => br.remove());
    
    // Get text content and normalize whitespace
    let textContent = clone.textContent || '';
    
    // Replace all types of whitespace characters (including &nbsp;, tabs, spaces, etc.)
    // Remove non-breaking spaces (&nbsp; = \u00A0)
    textContent = textContent.replace(/\u00A0/g, '');
    // Remove all other whitespace characters (spaces, tabs, line breaks, etc.)
    textContent = textContent.replace(/\s+/g, '');
    
    // Also check innerHTML for &nbsp; entity in case it hasn't been parsed yet
    let innerHTML = clone.innerHTML || '';
    // Remove HTML entities for non-breaking space and other whitespace entities
    innerHTML = innerHTML.replace(/&nbsp;/gi, '');
    innerHTML = innerHTML.replace(/&#160;/gi, '');  // Numeric entity for &nbsp;
    innerHTML = innerHTML.replace(/&#xa0;/gi, '');  // Hex entity for &nbsp;
    // Remove all HTML tags and check remaining content
    innerHTML = innerHTML.replace(/<[^>]*>/g, '');
    innerHTML = innerHTML.replace(/\s+/g, '');
    
    // If no meaningful content remains in both text and HTML, paragraph is empty
    return textContent === '' && innerHTML === '';
  }

  function hideEmptyParagraphs() {
    // Only target paragraphs inside .product-tabs__tab-item-content .container on product detail pages
    const containers = document.querySelectorAll('.product-tabs__tab-item-content .container');
    
    // If no containers exist, exit early
    if (containers.length === 0) {
      return;
    }
    
    // Process all matching containers (in case there are multiple tabs)
    containers.forEach(container => {
      // Get all paragraphs within each container
      const paragraphs = container.querySelectorAll('p');
      
      paragraphs.forEach(paragraph => {
        // Skip if already hidden
        if (paragraph.classList.contains('hide-empty-br')) {
          return;
        }
        
        // Check if paragraph is effectively empty (only contains <br> tags, &nbsp;, or whitespace)
        if (isParagraphEffectivelyEmpty(paragraph)) {
          paragraph.classList.add('hide-empty-br');
          paragraph.style.display = 'none';
        }
      });
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideEmptyParagraphs);
  } else {
    // DOM already loaded
    hideEmptyParagraphs();
  }

  // Also run after dynamic content loads (e.g., AJAX, theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', hideEmptyParagraphs);
  }

  // Run after a short delay to catch any dynamically added content
  setTimeout(hideEmptyParagraphs, 500);
  
  // Use MutationObserver to catch dynamically added paragraphs
  // Only observe changes within .product-tabs__tab-item-content
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if the added node is a paragraph or contains paragraphs
              if (node.tagName === 'P' || (node.querySelector && node.querySelector('p'))) {
                // Verify it's within the target container structure
                if (node.closest && node.closest('.product-tabs__tab-item-content .container')) {
                  shouldCheck = true;
                } else if (node.matches && node.matches('.product-tabs__tab-item-content .container')) {
                  shouldCheck = true;
                }
              }
            }
          });
        }
      });
      
      if (shouldCheck) {
        hideEmptyParagraphs();
      }
    });

    // Observe the parent container for when tabs switch or content changes
    const parentContainer = document.querySelector('.product-tabs__tab-item-content');
    if (parentContainer) {
      observer.observe(parentContainer, {
        childList: true,
        subtree: true
      });
    }
  }
})();

